import { ActionTile } from '@g17eco/atoms/action-tile/ActionTile';
import { DocumentProps, isFileDocumentProps } from './utils';
import { FlickityWrapper } from '@g17eco/molecules/flickity-wrapper';
import EditButton from '@g17eco/molecules/button/EditButton';
import { CLOSED_PHOTO_INDEX, G17Lightbox } from '@g17eco/molecules/lightbox';
import { DocumentMediaType, InitiativeDocument } from '@g17eco/types/document';
import { useState, useMemo } from 'react';

interface Props {
  displayDocuments: InitiativeDocument[];
  currentDocType: DocumentProps;
  initiativeId: string;
  editHandler: (media: InitiativeDocument) => void;
  addDisplayDocument: () => void;
  canEdit: boolean;
}

const options = {
  cellAlign: 'left',
  pageDots: true,
  draggable: true,
  groupCells: true,
};

const MAX_DISPLAYED_FILES = 5;

export const MediaTabContent = (props: Props) => {
  const { displayDocuments, currentDocType, initiativeId, editHandler, addDisplayDocument, canEdit } = props;
  const [photoIndex, setPhotoIndex] = useState(-1);
  const slides = useMemo(
    () =>
      displayDocuments.map((doc) => ({
        src: doc.url,
        title: doc.title,
        description: doc.description ? <p>{doc.description}</p> : undefined,
      })),
    [displayDocuments],
  );

  if (displayDocuments.length === 0) {
    if (currentDocType.key === DocumentMediaType.Assurance || !canEdit) {
      return <div className='alert alert-primary mt-4'>There are no files currently available</div>;
    }

    return (
      <ActionTile
        onClick={addDisplayDocument}
        icon={'fa-plus'}
        title='Display media'
        subtitle='Choose from files in your document library'
      />
    );
  }

  if (isFileDocumentProps(currentDocType)) {
    return currentDocType.render(displayDocuments.slice(0, MAX_DISPLAYED_FILES), editHandler, initiativeId, canEdit);
  }

  return (
    <>
      <FlickityWrapper disableImagesLoaded={true} reloadOnUpdate={true} options={options}>
        {displayDocuments.slice(0, MAX_DISPLAYED_FILES).map((doc, index) => {
          return (
            <div key={doc._id}>
              {currentDocType.render(doc, () => setPhotoIndex(index))}
              {canEdit ? <EditButton outline={false} onClick={() => editHandler(doc)} className='removeButton' /> : null}
            </div>
          );
        })}
      </FlickityWrapper>

      <G17Lightbox slides={slides} photoIndex={photoIndex} handleReset={() => setPhotoIndex(CLOSED_PHOTO_INDEX)} hasCaptions />
    </>
  );
};
